import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export const propertyName2Comment: Record<types.NetSuiteSubsidiariesPropertyName, string> = {
  internalId: 'internalId',
  name: 'name'
};



export const propertyName2Data: Record<types.NetSuiteSubsidiariesPropertyName, ImportCsvModal.IFormatTypeData> = {
  internalId: {
    example: "3",
    properFormat: "",
    fnValidate: () => true
  },
  name: {
    example: "BC Rich Guitars",
    properFormat: "",
    fnValidate: () => true
  }
};
